<script>
  import pages from './pages';
  import {getContext} from 'svelte';
  // import MobileNavbar from '../reusableitems/mobileNavbar.svelte';

  const {url} = getContext('APP');
  let viewPortHeight;
  let scrollY;

</script>

<svelte:window bind:scrollY={scrollY} bind:innerHeight={viewPortHeight} />
<section>
  <!-- <div class="navbar">
    <MobileNavbar />
  </div> -->
 
  <div class="main-div">	
      <svelte:component this={pages[$url.pathname]} viewPortHeight={viewPortHeight} scrollY={scrollY}/>
  </div>
</section>

<style>
      /* .navbar{
        width: 100%;
    position: fixed;
    z-index: 10;
    } */
  .main-div {
      z-index: 1;
      width: 100%;
  }
</style>
